import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import AdminApiClient from "../../../utils/http-clients/AdminApiClient";
import { ICompanyResponse, ICompanyState } from "../../types";

const adminApiClient = AdminApiClient.getInstance();

export const fetchCreateROC = createAsyncThunk(
  "listCompanies/fetchCreateROC",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createROC(params);
      return response.data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error);
    }
  }
);

const initialState: ICompanyState = {
  isLoading: false,
  response: null,
  error: null,
};

const createROCSlice = createSlice({
  name: "states/show",
  initialState,
  reducers: {
    resetCreateROC: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCreateROC.pending, (state) => {
      state.isLoading = true;
      state.response = null;
      state.error = null;
    });

    builder.addCase(
      fetchCreateROC.fulfilled,
      (state, action: PayloadAction<ICompanyResponse>) => {
        state.isLoading = false;
        state.response = action.payload;
        state.error = null;
      }
    );

    builder.addCase(fetchCreateROC.rejected, (state, action) => {
      state.isLoading = false;
      state.response = null;
      state.error = action.payload;
    });
  },
});

export default createROCSlice.reducer;
export const { resetCreateROC } = createROCSlice.actions;
